const win = window as any;
if (!win.CM) win.CM = {};
if (!win.CM.ux) win.CM.ux = {};

win.CM.ux.validateCsl = (value: string, completed: (isValid: boolean, message: string) => void) => {
    if (!value || value.indexOf('{{') === -1) {
        completed(true, 'No CSL found.');
    } else {
        $.ajax({
            type: 'POST',
            url: '/2/csl/validate',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({ text: value }),
        })
            .done((x) => completed(!!x?.isSyntaxValid, x?.message ?? 'CSL is valid.'))
            .fail((e) => completed(null, e?.statusText ?? 'Server request failed'));
    }
};

// compatibility
win.CM.validateCsl = win.CM.ux.validateCsl;
